import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const testRoot = document.getElementById('root');
if(testRoot)
{
  const root = ReactDOM.createRoot(testRoot);


root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  // reportWebVitals();
}
